import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box, TextInput, Switch, Group, Button } from '@mantine/core'
import { useForm } from "@mantine/form";
import axios from 'axios';
import { showMessage } from "../../lib/notification";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import produce from "immer";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";
import type { IResponse } from "../../types/api";
import type { ICustomer } from "./types";

type FormValues = Pick<ICustomer, 'email' | 'name' | 'phoneNumber' | 'roleCode' | "isActive">;

const EditCategory = () => {

    const { state: id = null } = useLocation();

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            email: '',
            name: '',
            phoneNumber: '',
            roleCode: 'admin',
            isActive: false
        },
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.get<IResponse<ICustomer>>(`${API_ROUTE}/${id}`);
            const values = produce(data.result, draft => {
                if (draft.phoneNumber) {
                    draft.phoneNumber = Number(draft.phoneNumber);
                }
            })
            form.setValues(values);
            form.resetDirty();
        }
        void fetchData();
    }, []);

    const handleSubmit = async (values: typeof form.values) => {
        const params = {
            isActive: values.isActive,
        }
        const { data } = await axios.post<IResponse<any>>(`${API_ROUTE}/${id}`, params);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green')
        } else {
            showMessage('Алдаа гарлаа')
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} засах`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto">

                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            disabled
                            withAsterisk
                            label="Имэйл"
                            placeholder="Имэйл оруулна уу"
                            {...form.getInputProps('email')}
                        />

                        <Switch
                            label="Идэвхтэй эсэх"
                            {...form.getInputProps('isActive', { type: 'checkbox' })}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default EditCategory;